export default __webpack_public_path__ + "4797b21f325b82a7a05ea1bbcdafec1e.png";